<template>
  <v-form>
    <v-container>
      <v-snackbar
        v-model="snackbarActionBtn"
        :vertical="vertical"
        :timeout="-1"
      >
        {{ snackbarText }}
        <template v-slot:action="{ attrs }">
          <v-btn
            v-if="actionButtonText"
            color="white"
            text
            v-bind="attrs"
            @click="onActionButtonClick"
          >
            {{ actionButtonText }}
          </v-btn>
          <v-btn
            :color="snackbarColor"
            text
            v-bind="attrs"
            @click="closeSnackbar"
          >
            CLOSE
          </v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </v-form>
</template>

<script lang="ts">
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "SnackBar",
  props: {
    snackbarAction: { type: Boolean, default: false },
    snackbarText: { type: String, default: "" },
    snackbarColor: { type: String, default: "" },
    actionButtonText: { type: String, default: "" },
    actionButtonRoute: { type: String, default: "" },
  },
  data() {
    return {
      snackbarActionBtn: false,
      vertical: true,
    };
  },
  watch: {
    snackbarAction: {
      handler(newValue) {
        this.snackbarActionBtn = newValue;
      },
      immediate: true,
    },
  },
  methods: {
    closeSnackbar() {
      this.snackbarActionBtn = false;
      this.$emit("closeSnackbar");
    },
    onActionButtonClick() {
      this.snackbarActionBtn = false;
      this.$emit("actionButtonClick");
    },
  },
});
</script>
